"use client";

import { trackAgentRevenueOfferClicked } from "@/lib/analytics-agent-offers";
import { safeSessionSet } from "@/lib/browser-storage";
import {
  ISHVARAM_COMMERCE_SYSTEM,
  ISHVARAM_REPORT_CHECKOUT_CHANNEL,
} from "@/lib/commerce-attribution";
import type { PaidReportCTAProps } from "./PaidReportCTA.types";

type CollectInputsArgs = Pick<PaidReportCTAProps, "analyticsContext" | "planId"> & {
  href: string;
};

export function startReportInputCollection({ analyticsContext, href, planId }: CollectInputsArgs) {
  const sourcePath = inputCollectionSourcePath(analyticsContext);
  persistReportInputIntent({ analyticsContext, planId, sourcePath });
  trackReportInputCollection({ analyticsContext, planId, sourcePath });
  window.location.href = href;
}

function inputCollectionSourcePath(
  analyticsContext: PaidReportCTAProps["analyticsContext"]
): string | undefined {
  if (analyticsContext?.sourcePath) return analyticsContext.sourcePath;
  return typeof window !== "undefined" ? window.location.pathname || undefined : undefined;
}

function persistReportInputIntent({
  analyticsContext,
  planId,
  sourcePath,
}: Pick<CollectInputsArgs, "analyticsContext" | "planId"> & { sourcePath?: string }) {
  try {
    if (analyticsContext?.intent) safeSessionSet("seo_entry_intent", analyticsContext.intent);
    if (sourcePath) safeSessionSet("seo_entry_path", sourcePath);
    safeSessionSet("seo_entry_primary_offer", "report");
    safeSessionSet("seo_entry_report_plan_id", planId);
  } catch {
    // Navigation still works when session storage is unavailable.
  }
}

function trackReportInputCollection({
  analyticsContext,
  planId,
  sourcePath,
}: Pick<CollectInputsArgs, "analyticsContext" | "planId"> & { sourcePath?: string }) {
  const {
    agentTraceId,
    checkoutChannel = ISHVARAM_REPORT_CHECKOUT_CHANNEL,
    commerceSystem = ISHVARAM_COMMERCE_SYSTEM,
    customerProblem,
    intent,
    placement = "report_landing_primary_offer",
    rankedOfferOrder,
    routeRankReason,
    routeRankScore,
  } = analyticsContext ?? {};
  trackAgentRevenueOfferClicked({
    source_path: sourcePath,
    intent,
    offer_type: "report",
    plan_id: planId,
    placement,
    checkout_channel: checkoutChannel,
    commerce_system: commerceSystem,
    customer_problem: customerProblem,
    route_rank_score: routeRankScore,
    route_rank_reason: routeRankReason,
    ranked_offer_order: rankedOfferOrder,
    agent_trace_id: agentTraceId,
  });
}
